module.exports = __webpack_public_path__ + "front/img/logo02.99ca3dc5.png";